export default defineNuxtPlugin(async (nuxtApp) => {
  const { isPreview } = useCms()
  const { enablePreviewAccessibilityCheck } = useFeatureFlags()

  if (enablePreviewAccessibilityCheck && isPreview) {
    const vueAxe = await import('vue-axe')

    nuxtApp.vueApp.component('VueAxePopup', vueAxe.VueAxePopup)
    nuxtApp.vueApp.use(vueAxe.default, {
      auto: false,
    })

    // add custom styles to the axe popup
    useHead({
      style: [
        {
          textContent: `
           .va-popup-btn { 
              display: flex;
              justify-content: center;
              align-items: center;
              width: 2.5rem;
              height: 2.5rem;
           }

           .va-popup-btn span {
              width: 1.5rem;
              height: 1.5rem;
           }
          `
        }
      ]
    })
  }
  else {
    nuxtApp.vueApp.component('VueAxePopup', h('div'))
  }
})
